/**
 * Platform-neutral OIDC config types and endpoint helpers.
 *
 * Kept separate from `config.ts` so the native override (`config.native.ts`)
 * can reuse these without importing `./config` (which Metro would resolve back
 * to `config.native.ts` itself on device).
 */

export interface OidcConfig {
    issuer: string;
    clientId: string;
    redirectUrl: string;
    postLogoutRedirectUrl: string;
    scopes: string[];
}

/**
 * Token endpoints for the OIDC server.
 */
export const getOidcEndpoints = (issuer: string) => ({
    authorization: `${issuer}/connect/authorize`,
    token: `${issuer}/connect/token`,
    revocation: `${issuer}/connect/revocation`,
    userInfo: `${issuer}/connect/userinfo`,
});

export const OIDC_SCOPES = [
    'openid',
    'profile',
    'email',
    'offline_access',
    'raiseright',
    'auth',
    'ecomm',
    'crm',
    'fulfillment',
    'earnings',
    'wallet',
    // Requires the auth-service client to allow it, or authorize fails with invalid_scope.
    'operational-data-store',
]; // offline_access for refresh tokens
